module.exports = __webpack_public_path__ + "img/consultor-premium.345e8fae.png";